<template>
  <div
    v-show="items.length"
    class="contact-options"
  >
    <strong
      v-show="title.length"
      class="d-block pb-2"
    >{{ title }}</strong>
    <ul>
      <li
        v-for="(option, index) in items"
        :key="index"
        :style="getStyle"
      >
        <button
          class="btn-icon"
          :class="getCssClass(option)"
          @click="onClick(option)"
        />
        <span>
          {{ option.value }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import datalayer from 'app/mixin/datalayer'

export default {
  name: 'ContactOptions',
  mixins: [datalayer],
  props: {
    text: {
      type: String,
      default () {
        return ''
      }
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    calculateWidth: Boolean
  },
  data () {
    return {
      items: [],
      title: ''
    }
  },
  computed: {
    getStyle () {
      return {
        width: (this.calculateWidth ? `${(100 / this.options.length)}%` : 'auto')
      }
    }
  },
  created () {
    this.items = this.options || []
    this.title = this.text || ''
  },
  methods: {
    getCssClass (option) {
      return 'btn-contact-' + option.type
    },
    getHref (option) {
      switch (option.type) {
        case 'phone':
          return 'tel:' + option.value
        case 'email':
          return 'mailto:' + option.value
      }
    },
    onClick (option) {
      const href = this.getHref(option)

      this.gtmTrackEvent({
        category: 'Button',
        action: 'Click',
        label: `Contact ${option.type} (${href})`,
        eventCallback: function () {
          window.location.href = href
        }
      })
    }
  }
}
</script>
